import React, {Component} from 'react';
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import update from 'immutability-helper';

import './LeadSchema.scss';

class LeadSchema extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSave();
  };

  handleFieldChange = (e) => {
    const newData = {
      schema: {}
    };

    const value = e.target.value;
    newData.schema[e.target.name] = {
      $set: value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  };

  handlePublish = (e) => {
    e.preventDefault();
    this.props.onPublish();
  };

  handleUnpublish = (e) => {
    e.preventDefault();
    this.props.onUnpublish();
  };

  addField = (data) => {
    const change = {
      schema: {}
    };

    // Create a unique id for this field
    let uniqueId = 1;
    while (this.props.schema.items.find((f) => f.id === `${data.type}${uniqueId}`)) {
      uniqueId++;
    }

    change.schema.items = {
      $push: [{
        name: data.name,
        required: false,
        type: data.type,
        custom: data.custom,
        uiType: data.uiType,
        id: `${data.type}${uniqueId}`
      }]
    };

    const props = update(this.props, change);
    this.props.onChange(props);
  };

  onListSort = (changedOrder) => {
    const change = {
      schema: {}
    };

    change.schema.items = {
      $set: changedOrder
    };

    const props = update(this.props, change);
    this.props.onChange(props);
  };

  render() {
    if (this.props.schema) {
      const schema = this.props.schema;

      return (
        <section className='lead-schema mf-padding-top-20'>
          <ol className='breadcrumb'>
            <li>
              <Link to='/'>Forsiden</Link>
            </li>
            <li>
              <Link to='/leadSchemas/'>Skjemaer</Link>
            </li>
            {schema.name && <li className='active'>{schema.name}</li>}
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className='page-header'>
              <div className='pull-right'>
                {this.props.working && (
                  <span>
                    <i className='fa fa-spinner fa-pulse fa-fw'></i>{' '}
                    Arbeider...&nbsp;
                  </span>
                )}
                <button
                  type='submit'
                  className='btn btn-success'
                  disabled={!this.props.modified || this.props.working}
                >
                  {Boolean(schema.id) && <span>Lagre</span>}
                  {!schema.id && <span>Opprett skjema</span>}
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(schema.draft || schema.updated) || this.props.working || this.props.modified}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={schema.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {this.props.onArchive &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(schema.archived)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
              </div>
              <h1>
                {schema.name} <PublishStatusDot entry={schema} /><br/>
              </h1>
            </div>
          </form>

          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label>
                  Navn <em className='small text-muted'>(Påkrevet)</em>
                </label>
                <input
                  type='text'
                  name='name'
                  className='form-control'
                  defaultValue={schema.name}
                  disabled={this.props.working}
                  onChange={this.handleFieldChange}
                  required
                />
              </div>
              <div className='form-group'>
                <div className='mf-margin-bottom-10 '>
                  <label>
                    Skjematype <em className='small text-muted'>(Påkrevet)</em>
                  </label>
                  <select
                    type='text'
                    className='form-control'
                    name='type'
                    defaultValue={schema.type}
                    onChange={this.handleFieldChange}
                    required
                  >
                    <option value=''>-- Velg type skjema --</option>
                    <option value='TestDrive'>Prøvekjøring</option>
                    <option value='Workshop'>Verksted</option>
                    <option value='Campaign'>Kampanje</option>
                    <option value='CarQuestion'>Bilforespørsel</option>
                    <option value='CarParts'>Deler</option>
                    <option value='DealerContact'>Generelt</option>
                    <option value='Interest'>Meld interesse</option>
                    <option value='SellUsedCar'>Vi kjøper din bruktbil</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className='row mf-margin-top-20'>
            <div className='col-md-4'>
              <h1>Felter</h1>
              <h3>Persondata</h3>
              <ItemChoice name='Navn' type='name' onClick={this.addField} />
              <ItemChoice name='E-post' type='email' onClick={this.addField} />
              <ItemChoice name='Telefon' type='phone' onClick={this.addField} />
              <ItemChoice name='Adresse' type='address' onClick={this.addField} />
              <ItemChoice name='Postnummer' type='zip' onClick={this.addField} />
              <ItemChoice name='Sted' type='city' onClick={this.addField} />

              <h3>Bildata</h3>
              {/* <ItemChoice name='Merke' type='carMake' onClick={this.addField} /> */}
              {/* <ItemChoice name='Modell' type='carModel' onClick={this.addField} /> */}
              <ItemChoice name='Variant' type='carDescription' onClick={this.addField} />
              <ItemChoice name='Reg. nr.' type='registrationNumber' onClick={this.addField} />

              <h3>Bruktbil</h3>
              <ItemChoice name='Reg. nr. oppslag' title="Henter bildata fra vegvesenet" custom={true} uiType='registrationLookup' type='registrationLookup' onClick={this.addField} />

              <h3>Egendefinert <small>(Disse vil sendes som kommentarer)</small></h3>
              <ItemChoice name='Tekst - En linje' custom={true} uiType="text" type='string' onClick={this.addField} />
              <ItemChoice name='Tekst - Flere linjer' custom={true} uiType="textarea" type='string' onClick={this.addField} />
              <ItemChoice name='Nummer' custom={true} uiType="number" type='number' onClick={this.addField} />
              <ItemChoice name='Checkbox' custom={true} uiType="checkbox" type='array' onClick={this.addField} />
              <ItemChoice name='Radio' custom={true} uiType="radio" type='array' onClick={this.addField} />
              <ItemChoice name='Select' custom={true} uiType="select" type='string' onClick={this.addField} />

              <h3>Tekst <small>(F.eks overskrift til en gruppe felter)</small></h3>
              <ItemChoice name='Overskrift' custom={true} uiType="heading" type='heading' onClick={this.addField} />
            </div>
            <div className='col-md-8'>
              <SortableComponent
                items={schema.items}
                onChange={this.onListSort}
              />
            </div>
          </div>
        </section>
      );
    }
  }
}

const SortableItem = SortableElement(({value, onDelete, onRequiredChange, onItemValueChange, onItemValueRemove, onNameChange}) => (
  <div className="panel panel-success">
    <div className="panel-heading">
      <small className="pull-right">{value.type}</small>
      <h3 className="panel-title">{value.custom && 'Egendefinert: '}{value.name}</h3>
    </div>
    <div className="panel-body">
      <div className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-2">Navn</label>
          <div className="col-sm-6">
            <input className="form-control" type="text" onChange={onNameChange} defaultValue={value.customName || value.name} />
          </div>
        </div>
        {value.uiType !== 'heading' && <div className="form-group">
          <div className="col-sm-offset-2 col-sm-10">
            <div className="checkbox">
              <label>
                <input onClick={onRequiredChange} type="checkbox" defaultChecked={value.required} /> Påkrevet
              </label>
            </div>
          </div>
        </div>}
        {value.uiType === 'registrationLookup' && <div>
          <h5>Setter inn følgende felter</h5>
          <ul>
            <li>Regnr</li>
            <li>Kilometerstand</li>
            <li>Merke og modell</li>
            <li>Drivstoff</li>
            <li>Hjuldrift</li>
            <li>Farge</li>
          </ul>
          <small>All data sendes som kommentarer</small>
        </div>}
        {(value.uiType === 'checkbox' || value.uiType === 'radio' || value.uiType === 'select') &&
          <div>
            <div className="form-group">
              <label className="col-sm-2">Valg</label>
              <div className="col-sm-8">
                <input ref={(ref) => (self[`uiInput${value.id}`] = ref)} onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onItemValueChange(self[`uiInput${value.id}`].value);
                    self[`uiInput${value.id}`].value = '';
                  }
                }} className="form-control" type="text" placeholder="Legg til valg" />
              </div>
              <div className="col-sm-2">
                <button onClick={() => {
                  onItemValueChange(self[`uiInput${value.id}`].value);
                  self[`uiInput${value.id}`].value = '';
                }} type="submit" className="btn btn-default">Legg til</button>
              </div>
            </div>
            <div className="form-group" style={{padding: '10px'}}>
              <ul>
                {value.values && value.values.map((v, i) => <li key={`${i}-${v}`}><div>{v} <button type="button" className="btn btn-link btn-xs" onClick={() => onItemValueRemove(i)}><i className="fa fa-times" aria-hidden="true"></i> Slett</button></div></li>)}
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
    <div className="panel-footer clearfix">
      <button type="button" className="btn btn-danger btn-xs pull-right" onClick={onDelete}><i className="fa fa-times" aria-hidden="true"></i> Slett</button>
    </div>
  </div>
));

const SortableList = SortableContainer(({items, onDelete, onRequiredChange, onItemValueChange, onItemValueRemove, onNameChange}) => {
  return (
    <div>
      {items.map((item, index) => (
        <SortableItem
          onDelete={() => onDelete(index)}
          onRequiredChange={() => onRequiredChange(index, !item.required)}
          onItemValueChange={(value) => onItemValueChange(index, value)}
          onItemValueRemove={(valueIndex) => onItemValueRemove(index, valueIndex)}
          onNameChange={(e) => onNameChange(index, e.target.value)}
          key={item.id}
          index={index}
          value={item}
        />
      ))}
    </div>
  );
});

class SortableComponent extends Component {
  onSortEnd = ({oldIndex, newIndex}) => {
    const newValue = arrayMove(this.props.items, oldIndex, newIndex);
    this.props.onChange(newValue);
  };

  onDelete = (index) => {
    this.props.items.splice(index, 1);
    this.props.onChange(this.props.items);
  };

  onRequiredChange = (index, required) => {
    this.props.items[index].required = required;
    this.props.onChange(this.props.items);
  };

  onNameChange = (index, customName) => {
    this.props.items[index].customName = customName;
    this.props.onChange(this.props.items);
  };

  onItemValueRemove = (index, valueIndex) => {
    this.props.items[index].values.splice(valueIndex, 1);
    this.props.onChange(this.props.items);
  };

  onItemValueChange = (index, value) => {
    this.props.items[index].values = this.props.items[index].values || [];
    this.props.items[index].values.push(value);
    this.props.onChange(this.props.items);
  };


  render() {
    return (
      <SortableList
        lockAxis={'y'}
        pressDelay={250}
        lockToContainerEdges={true}
        helperClass="LeadSchema-panel-helper"
        items={this.props.items}
        onSortEnd={this.onSortEnd}
        onDelete={this.onDelete}
        onRequiredChange={this.onRequiredChange}
        onItemValueChange={this.onItemValueChange}
        onItemValueRemove={this.onItemValueRemove}
        onNameChange={this.onNameChange}
      />
    );
  }
}

const ItemChoice = (props) => {
  return (<button type="button" title={props.title} style={{margin: '2px'}} className="btn btn-primary" onClick={() => props.onClick(props)}>{props.name}</button>);
};

LeadSchema.defaultProps = {
  schema: null,
  modified: null,
  working: null
};

export default LeadSchema;
